
import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { Container, Row, Col, Badge, Button } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Multiselect from "multiselect-react-dropdown";
import { useForm } from "react-hook-form";
import {
  GetAllCountries,
  GetCategories,
  GetYearsOfOperation,
} from "../../API/endpoints/Common";
import { GetAllServices } from "../../API/endpoints/Discovery";
import { GetEngagementModels } from "../../API/endpoints/Brands";
import { EngagementModelDTO } from "../dtos/brand.dtos";
import { updateMarket } from "../../API/endpoints/Market";

interface MarketFromInputs {
  market: number;
  services: any[];
  engagement_model: any[];
  exclusivity: number;
  minimum_tenure: number;
  shipment_terms: [];
  category_focus: [];
  payment_terms: [];
  investments: number;
  remarks: "";
}

export default function PartnerEditMarket(props: any) {
  const [open, setOpen] = React.useState(false);

  const [selectedServices, setSelectedServices] = useState<any[]>([]);
  const [selectedEngagementModels, setSelectedEngagementModels] = useState<
    any[]
  >([]);
  const [selectedCategories, setSelectedCategories] = useState<any[]>([]);
  const [selectedShipmentTerms, setSelectedShipmentTerms] = useState<any[]>([]);
  const [selectedPaymentTerms, setSelectedPaymentTerms] = useState<any[]>([]);

  const [selectedExclusivity, setSelectedExclusivity] = useState<any>("");
  const [selectedTenure, setSelectedTenure] = useState<any>("");
  const [selectedInvestments, setSelectedInvestments] = useState<any>("");

  const [countries, setCountries] = useState([]);
  const [servicesList, setServicesList] = useState<any[]>([]);
  const [tenureList, setTenureList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [engagementModelList, setEngagementModelList] = useState<
    EngagementModelDTO[]
  >([]);
  const [selectedMarket, setSelectedMarket] = useState<any>("");

  const termsList: any[] = [
    {
      id: "CIF",
      name: "CIF",
    },
    {
      id: "FOB",
      name: "FOB",
    },
  ];

  const paymentTermsList: any[] = [
    {
      id: "COD",
      name: "COD",
    },
    {
      id: "Bank LC",
      name: "Bank LC",
    },
    {
      id: "30-60 Days Credit",
      name: "30-60 Days Credit",
    },
    {
      id: "Escrow",
      name: "Escrow",
    },
  ];

  const exclusivityList: any[] = [
    {
      id: 1,
      name: "Yes",
    },
    {
      id: 0,
      name: "No",
    },
  ];

  const investmentsList: any[] = [
    {
      id: "YES",
      name: "Yes",
    },
    {
      id: "NO",
      name: "No",
    },
    {
      id: "MAYBE",
      name: "Maybe",
    },
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
    clearErrors,
  } = useForm<MarketFromInputs>();

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleCloseMarket = () => {
    props.onClose();
  };

  const [age, setAge] = React.useState("");

  useEffect(() => {
    (async () => {
      const countries = await GetAllCountries(-1);
      setCountries(countries.data);
    })();
    (async () => {
      const years = await GetYearsOfOperation();
      setTenureList(years.data);
    })();
    (async () => {
      try {
        const response = await GetCategories();
        setCategories(
          response.data.map((item: any) => {
            return { ...item, id: item.display_name };
          })
        );
      } catch (error) {}
    })();
    getServicesList();
    getEngagementModelsList();
  }, [props]);

  useEffect(() => {
    if (
      props.marketData &&
      Object.keys(props.marketData).length > 0 &&
      Boolean(props.open)
    ) {
      const editableItem: any = props.marketData;

      const selectedMarket = editableItem?.country;
      const selectedExclusivity = exclusivityList.find(
        (e) => Boolean(e.id) === editableItem?.exclusivity
      );

      const selectedTenure: any = tenureList.find(
        (t: any) => t.name === editableItem?.minimum_tenure
      );

      const selectedInvestment = investmentsList.find(
        (i) => i.id === editableItem?.trade_marketing_investments
      );

      const services = servicesList.filter((s: any) =>
        editableItem?.service_capabilities?.includes(s.name)
      );
      const engagementModels = engagementModelList.filter((s: any) =>
        editableItem?.engagement_model?.includes(s.name)
      );
      const catFocus = categories.filter((s: any) =>
        editableItem?.category_focus?.includes(s.display_name)
      );

      const shipmentsTerms = termsList.filter((s: any) =>
        editableItem?.shipment_terms?.includes(s.id)
      );
      const paymentTerms = paymentTermsList.filter((s: any) =>
        editableItem?.payment_terms?.includes(s.id)
      );

      

      const eData = {
        id: editableItem?.id,
        market: editableItem?.country?.id,
        exclusivity: selectedExclusivity,
        minimum_tenure: selectedTenure?.id,
        shipment_terms: shipmentsTerms,
        payment_terms: paymentTerms,
        investments: selectedInvestment,
        services: services,
        engagement_model: engagementModels,
        category_focus: catFocus,
        remarks: editableItem?.remarks,
      };


      setSelectedMarket(eData.market);
      setSelectedCategories(eData?.category_focus);
      setSelectedServices(eData?.services);
      setSelectedEngagementModels(eData?.engagement_model);
      setSelectedShipmentTerms(eData?.shipment_terms);
      setSelectedPaymentTerms(eData?.payment_terms);

      setSelectedExclusivity(eData?.exclusivity?.id);
      setSelectedTenure(eData?.minimum_tenure);
      setSelectedInvestments(eData?.investments?.id);

      let defaults = {
        market: eData.market,
        exclusivity: eData?.exclusivity?.id,
        minimum_tenure: eData?.minimum_tenure,
        investments: eData?.investments?.id,
        remarks: eData?.remarks,
      };
      reset(defaults);
    }
  }, [
    props.marketData,
    reset,
    props.open,
    setValue,
    tenureList,
    servicesList,
    engagementModelList,
    categories,
  ]);

  const getServicesList = async () => {
    const response = await GetAllServices();
    if (response) {
      // const postServices: any[] = response?.data?.post_launch_service;
      // const preServices: any[] = response?.data?.pre_launch_service;
      const services = [
        {
          id: 1,
          name: "regulatory_compliance",
          display_name: "Regulatory Compliance",
        },
        {
          id: 2,
          name: "importation_clearance",
          display_name: "Importation & Clearance",
        },
        {
          id: 3,
          name: "warehousing_storage",
          display_name: "Warehousing & Storage",
        },
        {
          id: 4,
          name: "ecom_setup_mgmt",
          display_name: "Ecommerce Setup & Management",
        },
        {
          id: 5,
          name: "retail_distribution",
          display_name: "Retail Distribution",
        },
        {
          id: 6,
          name: "order_fulfilment",
          display_name: "Order Fulfilment",
        },
        {
          id: 7,
          name: "marketing",
          display_name: "Marketing",
        },
      ];
      setServicesList([...services]);
    }
  };

  const getEngagementModelsList = async () => {
    const response = await GetEngagementModels();
    if (response) {
      setEngagementModelList(response.data);
    }
  };

  const handleServicesChange = (selectedList: any) => {
    setSelectedServices([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedServices((services: any) => [
          ...services,
          {
            id: item.id,
            name: item.name,
            display_name: item.display_name,
          },
        ]);
        return true;
      }
    );
  };

  const handleRemoveService = (selectedList: any) => {
    setSelectedServices(selectedList);
  };

  const handleEngagementModelChange = (selectedList: any) => {
    setSelectedEngagementModels([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedEngagementModels((models: any) => [
          ...models,
          {
            id: item.id,
            name: item.name,
            display_name: item.display_name,
          },
        ]);
        return true;
      }
    );
  };

  const handleEngagementModelRemove = (selectedList: any) => {
    setSelectedEngagementModels(selectedList);
  };

  const handleCategoryChange = (selectedList: any) => {
    setSelectedCategories([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedCategories((categories: any) => [
          ...categories,
          {
            id: item.id,
            name: item.name,
            display_name: item.display_name,
          },
        ]);
        return true;
      }
    );
  };

  const handleCategoryRemove = (selectedList: any) => {
    setSelectedCategories(selectedList);
  };

  const handleShipmentChange = (selectedList: any) => {
    setSelectedShipmentTerms([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedShipmentTerms((items: any) => [
          ...items,
          {
            id: item.id,
            name: item.name,
          },
        ]);
        return true;
      }
    );
  };

  const handleShipmentRemove = (selectedList: any) => {
    setSelectedShipmentTerms(selectedList);
  };

  const handlePaymentChange = (selectedList: any) => {
    setSelectedPaymentTerms([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedPaymentTerms((items: any) => [
          ...items,
          {
            id: item.id,
            name: item.name,
          },
        ]);
        return true;
      }
    );
  };

  const handlePaymentRemove = (selectedList: any) => {
    setSelectedPaymentTerms(selectedList);
  };

  const onSubmitNewMarket = async (data: any) => {

    if (!validateForm()) {
      return;
    }

    if (data) {
      const selectedMarket = countries.find(
        (item: any) => item.id === data?.market
      );
      const selectedExclusivity = exclusivityList.find(
        (item: any) => item.id === data?.exclusivity
      );
      const selectedTenure = tenureList.find(
        (item: any) => item.id === data?.minimum_tenure
      );
      const selectedInvestment = investmentsList.find(
        (item: any) => item.id === data?.investments
      );

      const marketDataReq: any = {
        ...data,
        market: selectedMarket,
        exclusivity: selectedExclusivity,
        minimum_tenure: selectedTenure,
        shipment_terms: selectedShipmentTerms,
        payment_terms: selectedPaymentTerms,
        investments: selectedInvestment,
        services: selectedServices.sort((a, b) => a.id - b.id),
        engagement_model: selectedEngagementModels,
        category_focus: selectedCategories,
      };

      const marketReq = {
        partner_id: props.partnerID,
        region: marketDataReq?.market?.id,
        service_capabilities: marketDataReq?.services?.map(
          (service: any) => service?.name
        ),
        engagement_model: marketDataReq?.engagement_model?.map(
          (model: any) => model?.name
        ),
        shipment_terms: marketDataReq?.shipment_terms?.map(
          (terms: any) => terms?.id
        ),
        payment_terms: marketDataReq?.payment_terms?.map(
          (terms: any) => terms?.id
        ),
        category_focus: marketDataReq?.category_focus?.map(
          (cat: any) => cat?.id
        ),
        exclusivity: marketDataReq?.exclusivity?.id ? true : false,
        minimum_tenure: marketDataReq?.minimum_tenure?.name,
        trade_marketing_investments: marketDataReq?.investments?.id,
        remarks: marketDataReq.remarks,
      };

      const createdRes = await updateMarket(props.marketData.id, marketReq);

     
      setSelectedServices([]);
      setSelectedEngagementModels([]);
      setSelectedCategories([]);
      setSelectedPaymentTerms([]);
      setSelectedShipmentTerms([]);
      setSelectedExclusivity("");
      setSelectedInvestments("");
      setSelectedTenure("");
      clearErrors();
      reset();
      props.onSuccess();
    }
  };

  const validateForm = () => {

    selectedServices.length == 0
      ? setError("services", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("services");

    selectedPaymentTerms.length == 0
      ? setError("payment_terms", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("payment_terms");

    selectedShipmentTerms.length == 0
      ? setError("shipment_terms", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("shipment_terms");

    selectedEngagementModels.length == 0
      ? setError("engagement_model", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("engagement_model");

    selectedCategories.length == 0
      ? setError("category_focus", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("category_focus");

    if (
      selectedServices.length == 0 ||
      selectedPaymentTerms.length == 0 ||
      selectedShipmentTerms.length == 0 ||
      selectedEngagementModels.length == 0 ||
      selectedCategories.length == 0
    ) {
      return false;
    }

    return true;
  };

  return (
    <React.Fragment>
      <Dialog
        className="modal_700"
        open={props.open}
        onClose={handleCloseMarket}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Form onSubmit={handleSubmit(onSubmitNewMarket)}>
          {/* <Form onSubmit={handleSubmit(null)}> */}
          <DialogTitle id="alert-dialog-title">Edit Market </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseMarket}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent>
            <Row className="mb16px">
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ minWidth: "100%" }} size="small">
                  <label>Market</label>
                  <Select
                    placeholder="Select Market"
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="market"
                    {...register("market", {
                      required: "* This field is required",
                    })}
                    value={selectedMarket}
                    disabled
                  >
                    {countries.map((country: any) => {
                      return (
                        <MenuItem value={country.id} key={country.id}>
                          {country.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.market?.message}</p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Services Capability</label>
                  <Multiselect
                    key="services"
                    showArrow
                    options={servicesList}
                    displayValue="display_name"
                    showCheckbox={true}
                    customCloseIcon={<></>}
                    placeholder="Select Services"
                    closeIcon="cancel"
                    {...register("services")}
                    selectedValues={selectedServices}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleServicesChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleRemoveService(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.services?.message}</p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Engagement Model</label>
                  <Multiselect
                    {...register("engagement_model")}
                    showArrow
                    options={engagementModelList}
                    displayValue="display_name"
                    showCheckbox={true}
                    placeholder="Select Engagement Models"
                    closeIcon="cancel"
                    customCloseIcon={<></>}
                    selectedValues={selectedEngagementModels}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleEngagementModelChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleEngagementModelRemove(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.engagement_model?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ minWidth: "100%" }} size="small">
                  <label>Exclusivity</label>
                  <Select
                    placeholder="Select Exclusivity"
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="exclusivity"
                    {...register("exclusivity", {
                      required: "* This field is required",
                    })}
                    value={selectedExclusivity}
                    onChange={(e) => setSelectedExclusivity(e.target.value)}
                  >
                    {exclusivityList.map((term) => {
                      return (
                        <MenuItem value={term.id} key={term.id}>
                          {term.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.exclusivity?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ minWidth: "100%" }} size="small">
                  <label>Minimum Tenure</label>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="tenure"
                    placeholder="Select Minimum Tenure"
                    {...register("minimum_tenure", {
                      required: "* This field is required",
                    })}
                    value={selectedTenure}
                    onChange={(e) => setSelectedTenure(e.target.value)}
                  >
                    {tenureList.map((tenure: any) => {
                      return (
                        <MenuItem value={tenure.id} key={tenure.id}>
                          {tenure.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.minimum_tenure?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Shipment terms</label>
                  <Multiselect
                    showArrow
                    options={termsList}
                    displayValue="name"
                    showCheckbox={true}
                    placeholder="Select Shipment Terms"
                    closeIcon="cancel"
                    customCloseIcon={<></>}
                    {...register("shipment_terms")}
                    selectedValues={selectedShipmentTerms}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleShipmentChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleShipmentRemove(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.shipment_terms?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Payment terms</label>
                  <Multiselect
                    showArrow
                    options={paymentTermsList}
                    displayValue="name"
                    showCheckbox={true}
                    customCloseIcon={<></>}
                    placeholder="Select Payment Terms"
                    closeIcon="cancel"
                    {...register("payment_terms")}
                    selectedValues={selectedPaymentTerms}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handlePaymentChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handlePaymentRemove(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.payment_terms?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ minWidth: "100%" }} size="small">
                  <label>Trade and Marketing Investements</label>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="investments"
                    placeholder="Select"
                    {...register("investments", {
                      required: "* This field is required",
                    })}
                    value={selectedInvestments}
                    onChange={(e) => setSelectedInvestments(e.target.value)}
                  >
                    {investmentsList.map((term) => {
                      return (
                        <MenuItem value={term.id} key={term.id}>
                          {term.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.investments?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Category Focus</label>
                  <Multiselect
                    showArrow
                    options={categories}
                    displayValue="name"
                    showCheckbox={true}
                    customCloseIcon={<></>}
                    placeholder="Select"
                    closeIcon="cancel"
                    {...register("category_focus")}
                    selectedValues={selectedCategories}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleCategoryChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleCategoryRemove(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.category_focus?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={12} lg={12} xl={12}>
                <Form.Group controlId="">
                  <label>Remarks</label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="sample text"
                    {...register("remarks")}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.remarks?.message}</p>
                    </span>
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleCloseMarket}>
              Cancel
            </Button>
            <Button type="submit">
              Save
            </Button>
          </DialogActions>
        </Form>
      </Dialog>
    </React.Fragment>
  );
}
